import i18next from 'i18next';
import { useEffect } from 'react';

import En from '~assets/flag_en.svg';
import Es from '~assets/flag_es.svg';
import Por from '~assets/flag_por.svg';
import { useLocalStorage } from '~hooks/index';
import './Internationalization.scss';

export type LanguageCode = 'es' | 'en' | 'por';

const Internationalization = () => {
  const defaultLanguage = import.meta.env.VITE_DEFAULT_LANGUAGE as LanguageCode;
  const { userPermissions, language, setLanguage } = useLocalStorage();
  const currentLanguage = language || defaultLanguage;

  useEffect(() => {
    i18next.changeLanguage(currentLanguage);
  }, []);

  const handleLanguageChange = (lg: LanguageCode) => {
    setLanguage(lg);
    window.location.reload();
  };

  const languageActions = [
    {
      acronym: 'ES',
      label: 'Español',
      onClick: () => handleLanguageChange('es'),
      icon: Es,
      hasPermission: true
    },
    {
      acronym: 'EN',
      label: 'English',
      onClick: () => handleLanguageChange('en'),
      icon: En,
      hasPermission: userPermissions.includes('core.can_change_language_to_english')
    },
    {
      acronym: 'POR',
      label: 'Português',
      onClick: () => handleLanguageChange('por'),
      icon: Por,
      hasPermission: userPermissions.includes('core.can_change_language_to_portuguese')
    }
  ];

  return (
    <div className="internationalization d-flex align-items-center gap-2">
      <div className="d-flex gap-3">
        {languageActions.filter(item => item.hasPermission).map((language, index) => (
          <div
            key={`language_${index}`}
            onClick={language.onClick}
            style={{ cursor: 'pointer' }}
          >
            <span
              style={{
                fontSize: '12px',
                fontWeight:
                  language.acronym === currentLanguage.toUpperCase() ? 'bold' : 'normal'
              }}
            >
              {language.acronym}{' '}
            </span>
            <img
              src={language.icon}
              alt={language.label}
              className="language-icon"
              style={{ width: '20px', height: '20px' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Internationalization;
